export default __webpack_public_path__ + "static/CustomDomain-b5d086e9f0c4e6696b6e2dc0b5ffe0c7.jpg";